const projects = [{
  name: 'almost66',
  type: 'web_design',
  display: 'Almost Six Six',
  summary: 'Web design & development, logo design',
  images: [{
    src: 'almost66/unblurred.jpg',
    type: 'hero',
  }, {
    src: 'web%20design%20thumbs/almost_sixsix.jpg',
    type: 'thumb',
  },
  {
    src: 'almost66/a66-logo.jpg',
    type: 'portfolio',
  },
  {
    src: 'almost66/home-page.jpg',
    type: 'portfolio',
  },
  {
    src: 'almost66/mobile.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'brendanberry',
  type: 'web_design',
  display: 'BrendanBerry.com',
  summary: 'Web design & development, logo design',
  images: [{
    src: '/brendan_berry/bb.jpg',
    type: 'hero',
  }, {
    src: 'web%20design%20thumbs/brendan_berry.jpg',
    type: 'thumb',
  },
  {
    src: '/brendan_berry/1.jpg',
    type: 'portfolio',
  },
  {
    src: '/brendan_berry/2.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'craigdelorenzo',
  type: 'web_design',
  display: 'Craig DeLorenzo',
  summary: 'Web design & development, logo design',
  images: [{
    src: 'craig_delorenzo/cd.jpg',
    type: 'hero',
  }, {
    src: 'web%20design%20thumbs/craigdelorenzo.jpg',
    type: 'thumb',
  },
  {
    src: 'craig_delorenzo/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'craig_delorenzo/2.jpg',
    type: 'portfolio',
  },
  {
    src: 'craig_delorenzo/3.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'craighanson',
  type: 'web_design',
  display: 'Craig Hanson',
  summary: 'Web design & development, logo design',
  images: [{
    src: 'craig_hanson/ch.jpg',
    type: 'hero',
  }, {
    src: 'web%20design%20thumbs/craig_hanson.jpg',
    type: 'thumb',
  },
  {
    src: 'craig_hanson/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'craig_hanson/2.jpg',
    type: 'portfolio',
  },
  {
    src: 'craig_hanson/3.jpg',
    type: 'portfolio',
  },
  {
    src: 'craig_hanson/4.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'fogsnob',
  display: 'FogSnob',
  type: 'branding',
  summary: 'Web design & development, logo design',
  images: [{
    src: 'fifl/fs.jpg',
    type: 'hero',
  }, {
    src: 'branding/fogsnob.jpg',
  },
  {
    src: 'web%20design%20thumbs/fifl.jpg',
    type: 'thumb',
  },
  {
    src: 'fifl/fogsnob/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'fifl/fogsnob/2.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'joenottband',
  display: 'Joe Nott Band',
  type: 'web_design',
  summary: 'Web design & development, logo design',
  images: [{
    src: 'joe_nott/blurred.jpg',
    type: 'hero',
  }, {
    src: 'web%20design%20thumbs/joe_nott.jpg',
    type: 'thumb',
  },
  {
    src: 'joe_nott/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'joe_nott/2.jpg',
    type: 'portfolio',
  },
  {
    src: 'joe_nott/3.jpg',
    type: 'portfolio',
  },
  {
    src: 'joe_nott/4.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'illustration',
  display: 'Illustration',
  type: 'illustration',
  summary: 'Freelance & personal work',
  images: [{
    src: 'illustration/blurred.jpg',
    type: 'hero',
  }, {
    src: 'illustration/campzombie.jpg',
    type: 'thumb',
  },
  {
    src: 'illustration/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'illustration/2.jpg',
    type: 'portfolio',
  },
  {
    src: 'illustration/3.jpg',
    type: 'portfolio',
  },
  {
    src: 'illustration/4.jpg',
    type: 'portfolio',
  },
  {
    src: 'illustration/5.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'jvw',
  display: 'JVW inc.',
  type: 'branding',
  summary: 'Logo design & branding',
  images: [{
    src: 'jvw/blurred.jpg',
    type: 'hero',
  }, {
    src: 'branding/jvw.jpg',
    type: 'thumb',
  },
  {
    src: 'jvw/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'jvw/2.jpg',
    type: 'portfolio',
  },
  {
    src: 'jvw/3.jpg',
    type: 'portfolio',
  },
  {
    src: 'jvw/4.jpg',
    type: 'portfolio',
  },
  ],
},
{
  name: 'mstream',
  display: 'mStream - streaming media',
  type: 'web_design',
  summary: 'Web design & development, logo design',
  images: [{
    src: 'mstream/blurred.jpg',
    type: 'hero',
  }, {
    src: 'web%20design%20thumbs/mstream.jpg',
    type: 'thumb',
  },
  {
    src: 'mstream/1.jpg',
    type: 'portfolio',
  },
  {
    src: 'mstream/2.jpg',
    type: 'portfolio',
  },
  {
    src: 'mstream/3.jpg',
    type: 'portfolio',
  },
  {
    src: 'mstream/4.jpg',
    type: 'portfolio',
  },
  ],
},
];

export default projects;
